export default "https://cdn-web.disco.co/slack-auto-connect-mobile-2-af218550c5566e19aeac01ee01fd182b.png";